import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { MeterList } from "@/pages";
import React from "react";
import { permissionsEnergy } from "@/utils";
import { locationMeterDataRoutes } from "./locationMeterDataRoutes";

export const locationMeterRoutes = (
  parentPath: string,
): React.ReactElement[] => [
  <Route
    key="meters"
    path=""
    element={
      <ProtectedRoute element={<MeterList />} codes={permissionsEnergy} />
    }
  />,
  <Route path=":meterNo/data">{locationMeterDataRoutes(parentPath)}</Route>,
];
